const categoryVariantClasses = 'overline-m mb-4 text-blue-500';

const containerVariantClasses = 'px-6 py-4';

const minutesReadVariantClasses = 'text-[0.9rem] leading-[1.2rem] text-gray-700';

const summaryVariantClasses = 'paragraph-s mb-8 text-gray-300';

const titleVariantClasses = 'display-xs text-gray-900';

const cardBlogTheme = {
  categoryVariantClasses,
  containerVariantClasses,
  minutesReadVariantClasses,
  summaryVariantClasses,
  titleVariantClasses,
};

export default cardBlogTheme;
